import { apiRequest,getToken } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";



export const downloadReport = createAsyncThunk("Report/downloadReport",
async (tableListingAllData,{dispatch}) => {
 const req = `${BASE_URL}/organisation/downloadReport`
 const _options = {
   method: 'POST',
   headers: {
     "Content-Type": "application/json"
   },
   body: JSON.stringify(tableListingAllData)
 }
 
 try {
   const result = await encryptPayload(req, _options, false, false,true);
  
   return result;
  }
  catch (err) {
    console.log(err)
  }
})

